import * as $ from "jquery";

export class EnrollSelectLive {
    courses: string;
    calendar: string;
    texas: string;
    classtype: number;
    isScorePerfect: boolean;
    $region: JQuery;
    $vicinity: JQuery;
    $modal: JQuery;

    constructor(
        courses: string,
        calendar: string,
        texas: string,
        classtype: number,
        isScorePerfect: boolean,
    ) {
        const self = this;
        self.courses = courses;
        self.calendar = calendar;
        self.texas = texas;
        self.classtype = classtype;
        self.isScorePerfect = isScorePerfect;
        self.$modal = $(".modal");
        self.$vicinity = $("#VicinityID");

        if (self.isScorePerfect) {
            self.$vicinity.prop("disabled", false);
            if (self.getVicinityId()) {
                self.populateCities();
            }
        } else {
            // if vicinity is already populated then we assume it's selected
            self.$region = $("#RegionID");

            if (self.getRegionId()) {
                if (self.getVicinityId()) {
                } else {
                    self.populateVicinity();
                }
            } else {
                self.$vicinity.prop("disabled", true);
            }

            // When a region is selected, clear existing information and populate the vicinity list
            self.$region.on("change", function () {
                self.populateVicinity();

                // Enable the vicinity dropdown if the region is selected
                const noRegion = self.getRegionId() === 0;
                self.$vicinity.prop("disabled", noRegion);
            });
        }

        // When a vicinity is selected, populate the cities field
        self.$vicinity.on("change", function () {
            self.populateCities();
            self.$vicinity.prop("disabled", false);
            if (self.getVicinityId() === 0) {
                // Display nothing if no vicinity is chosen
                $(".courses.overflow").css("display", "none");
            } else {
                $(".courses.overflow").css("display", "block");
            }
        });

        // calendar buttons
        $(".courses").on("click", ".modal-trigger", function () {
            const $img = $(this);
            self.showCalendar(
                parseInt($img.data("courseid")),
                $img.data("coursename"),
            );
        });

        const $modelclose = this.$modal.find(".fa");
        const $modelmask = this.$modal.find(".mask");

        $modelclose.on("click", function () {
            self.$modal.hide();
        });
        $modelmask.on("click", function () {
            self.$modal.hide();
        });
    }

    /* ---- CONTROLLER ---- */
    populateVicinity() {
        // If the region is Texas, redirect to ScorePerfect
        if (this.getRegionId() < 0) {
            this.$region.find("option:first-child").attr(
                "selected",
                "selected",
            );
            window.location.href = this.texas;
            return;
        }

        this.populateDropDown(
            "/Register/Vicinity/" + this.classtype + "?region=",
            "- Select a city or region -",
        );
        this.clearCities();
    }

    /* ---- DROPDOWNS ---- */
    populateDropDown(baseurl: string, selecttext: string) {
        const self = this;
        $.getJSON(
            baseurl + self.getRegionId(),
            {},
            function (data, textStatus) {
                let placeholder = '<option value="">' + selecttext +
                    "</option>";
                $.each(data, function (id, jsonData) {
                    placeholder += "<option value='" + jsonData.Value + "'>" +
                        jsonData.Text + "</option>";
                });
                self.$vicinity.html("");
                self.$vicinity.append(placeholder);
                // Disable vicinity dropdown if region is cleared
            },
        ).fail(function (e) {
            self.$vicinity.prop("disabled", true);
            self.clearDropDown(self.$vicinity, "- Select a city or region -");
        });
    }

    clearDropDown($dd: JQuery, selecttext: string) {
        $dd.html(""); // empty the select
        if (selecttext) {
            $dd.append($('<option value="">' + selecttext + "</option>"));
        }
    }

    /* ---- CITIES FIELD ---- */
    populateCities() {
        $(".courses").load(this.courses + this.getVicinityId());
    }

    clearCities() {
        $(".courses").html("");
    }

    /* ---- CALENDAR TOGGLE ---- */
    showCalendar(id: number, name: string) {
        // Load calendar data into modal
        $(".target").load(this.calendar + id);
        this.$modal.find(".title h1").text(name);
        this.$modal.fadeIn().css("display", "flex");
    }

    getVicinityId(): number {
        const aVicinity = this.$vicinity.val();
        if (aVicinity) {
            return parseInt(<string> aVicinity);
        } else {
            return 0;
        }
    }

    getRegionId(): number {
        const aRegion = this.$region.val();
        if (aRegion) {
            return parseInt(<string> aRegion);
        } else {
            return 0;
        }
    }
}
